(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-hero-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pps-hero-promo')) return;

    var DESKTOP = '(min-width: 750px)';

    class PpsHeroPromo extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pps-track]');
        this.prevBtn = this.querySelector('[data-pps-prev]');
        this.nextBtn = this.querySelector('[data-pps-next]');
        this.controls = this.querySelector('[data-pps-controls]');
        this.dotsEl = this.querySelector('[data-pps-dots]');
        this.counter = this.querySelector('[data-pps-counter]');
        this.playBtn = this.querySelector('[data-pps-play]');
        this.gridWrap = this.querySelector('[data-pps-grid-wrap]');
        this.grid = this.querySelector('[data-pps-grid]');
        this.mq = window.matchMedia(DESKTOP);
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pauseReasons = new Set();
        this.page = 0;
        this.pages = 1;

        this._refresh = this.refresh.bind(this);
        this._onScroll = this.onScroll.bind(this);
        this._onSelect = this.onEditorSelect.bind(this);
        this._onDeselect = this.onEditorDeselect.bind(this);
        this._onVisibility = function () {
          document.hidden ? this.pause('tab') : this.resume('tab');
        }.bind(this);

        if (this.track) {
          this.track.addEventListener('scroll', this._onScroll, { passive: true });
          this.track.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.page + 1, true); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.page - 1, true); }
          }.bind(this));
          var self = this;
          ['mouseenter', 'focusin'].forEach(function (ev) { self.addEventListener(ev, function () { self.pause('hover'); }); });
          ['mouseleave', 'focusout'].forEach(function (ev) { self.addEventListener(ev, function () { self.resume('hover'); }); });
          this.track.addEventListener('touchstart', function () {
            self.pause('touch');
            clearTimeout(self._touchT);
            self._touchT = setTimeout(function () { self.resume('touch'); }, 8000);
          }, { passive: true });
        }
        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { this.go(this.page - 1, true); }.bind(this));
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { this.go(this.page + 1, true); }.bind(this));
        if (this.playBtn) this.playBtn.addEventListener('click', function () {
          if (this.pauseReasons.has('user')) { this.resume('user'); } else { this.pause('user'); }
          this.syncPlayBtn();
        }.bind(this));

        if (this.mq.addEventListener) this.mq.addEventListener('change', this._refresh);
        window.addEventListener('resize', this._refresh);
        document.addEventListener('visibilitychange', this._onVisibility);
        document.addEventListener('shopify:block:select', this._onSelect);
        document.addEventListener('shopify:block:deselect', this._onDeselect);
        this._clock = setInterval(this._refresh, 30000);

        this.refresh();
        this.startAutoplay();
      }

      disconnectedCallback() {
        clearInterval(this._clock);
        clearInterval(this._auto);
        window.removeEventListener('resize', this._refresh);
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._refresh);
        document.removeEventListener('visibilitychange', this._onVisibility);
        document.removeEventListener('shopify:block:select', this._onSelect);
        document.removeEventListener('shopify:block:deselect', this._onDeselect);
      }

      /* Programación en cliente: oculta/mostrar según data-start / data-end */
      applySchedule() {
        var now = Date.now() / 1000;
        this.querySelectorAll('[data-pps-item][data-start], [data-pps-item][data-end]').forEach(function (el) {
          var s = parseFloat(el.dataset.start || 0);
          var e = parseFloat(el.dataset.end || 0);
          el.hidden = (s && now < s) || (e && now > e);
        });
      }

      visible(container) {
        if (!container) return [];
        return Array.prototype.filter.call(container.children, function (el) {
          return el.hasAttribute('data-pps-item') && !el.hidden && getComputedStyle(el).display !== 'none';
        });
      }

      refresh() {
        this.applySchedule();
        this.layoutSlider();
        this.layoutGrid();
        var hasSlides = this.track && this.visible(this.track).length > 0;
        var hasGrid = this.gridWrap && !this.gridWrap.hidden;
        if (!window.Shopify || !Shopify.designMode) {
          var host = this.closest('.shopify-section') || this;
          host.hidden = !hasSlides && !hasGrid;
        }
      }

      layoutSlider() {
        if (!this.track) return;
        var slider = this.track.closest('[data-pps-slider]');
        var items = this.visible(this.track);
        var n = items.length;
        if (slider) slider.hidden = n === 0;
        var perView = this.mq.matches ? parseInt(this.dataset.perView || '2', 10) : 1;
        if (this.mq.matches) this.style.setProperty('--pv-d', Math.max(1, Math.min(perView, n)));
        this.perView = Math.max(1, Math.min(perView, n));
        this.items = items;
        this.pages = n <= this.perView ? 1 : Math.ceil(n / this.perView);
        var multi = this.pages > 1;
        if (this.prevBtn) this.prevBtn.hidden = !multi;
        if (this.nextBtn) this.nextBtn.hidden = !multi;
        if (this.controls) this.controls.hidden = !multi;
        items.forEach(function (el, i) {
          el.setAttribute('role', 'group');
          el.setAttribute('aria-roledescription', 'slide');
          el.setAttribute('aria-label', (i + 1) + ' / ' + n);
        });
        this.buildDots();
        if (this.page > this.pages - 1) this.page = 0;
        this.onScroll();
        if (!multi) this.stopAutoplay(); else this.startAutoplay();
      }

      buildDots() {
        if (this.counter) this.counter.querySelector('[data-pps-total]').textContent = this.pages;
        var bars = this.classList.contains(this.mq.matches ? 'pps-hero--pag-d-bars' : 'pps-hero--pag-m-bars');
        this.classList.toggle('pps-hero--bars-active', bars);
        if (!this.dotsEl) return;
        if (this.dotsEl.childElementCount === this.pages) return;
        var tpl = this.dotsEl.dataset.label || '__I__ / __N__';
        this.dotsEl.innerHTML = '';
        for (var i = 0; i < this.pages; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'pps-hero__dot';
          d.setAttribute('aria-label', tpl.replace('__I__', i + 1).replace('__N__', this.pages));
          d.addEventListener('click', this.go.bind(this, i, true));
          this.dotsEl.appendChild(d);
        }
      }

      step() {
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        var first = this.items && this.items[0];
        var w = first ? first.getBoundingClientRect().width : this.track.clientWidth;
        return (this.perView || 1) * (w + gap);
      }

      currentPage() {
        var max = this.track.scrollWidth - this.track.clientWidth;
        var x = Math.abs(this.track.scrollLeft);
        if (max > 0 && x >= max - 2) return this.pages - 1;
        return Math.min(this.pages - 1, Math.round(x / this.step()));
      }

      onScroll() {
        if (!this.track) return;
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(function () {
          this.page = this.currentPage();
          if (this.dotsEl) {
            Array.prototype.forEach.call(this.dotsEl.children, function (d, i) {
              var cur = i === this.page ? 'true' : 'false';
              if (d.getAttribute('aria-current') !== cur) d.setAttribute('aria-current', cur);
            }, this);
          }
          if (this.counter) this.counter.querySelector('[data-pps-current]').textContent = this.page + 1;
          var self = this;
          (this.items || []).forEach(function (el, i) {
            var on = Math.floor(i / self.perView) === self.page || (self.page === self.pages - 1 && i >= self.items.length - self.perView);
            el.setAttribute('aria-hidden', on ? 'false' : 'true');
            el.querySelectorAll('a').forEach(function (a) { on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'); });
          });
        }.bind(this));
      }

      go(p, user) {
        if (!this.track || this.pages < 2) return;
        if (p > this.pages - 1) p = this.hasAttribute('data-loop') ? 0 : this.pages - 1;
        if (p < 0) p = this.hasAttribute('data-loop') ? this.pages - 1 : 0;
        var max = this.track.scrollWidth - this.track.clientWidth;
        var left = Math.min(p * this.step(), max);
        this.track.scrollTo({ left: left, behavior: this.reduced ? 'auto' : 'smooth' });
        this.page = p;
        if (user) this.restartAutoplay();
      }

      /* ---------- Autoplay ---------- */
      startAutoplay() {
        var s = parseFloat(this.dataset.autoplay || 0);
        if (!s || this._auto || this.reduced || this.pages < 2) return;
        this._auto = setInterval(function () {
          if (this.pauseReasons.size) return;
          if (!this.hasAttribute('data-loop') && this.page >= this.pages - 1) return;
          this.go(this.page + 1);
        }.bind(this), s * 1000);
        this.syncPlayBtn();
      }
      stopAutoplay() { clearInterval(this._auto); this._auto = null; }
      restartAutoplay() {
        if (!this._auto) return;
        this.stopAutoplay(); this.startAutoplay();
        // Reinicia la barra de progreso activa
        var cur = this.dotsEl && this.dotsEl.querySelector('[aria-current="true"]');
        if (cur) { cur.setAttribute('aria-current', 'false'); void cur.offsetWidth; cur.setAttribute('aria-current', 'true'); }
      }
      pause(r) { this.pauseReasons.add(r); this.syncPaused(); }
      resume(r) { this.pauseReasons.delete(r); this.syncPaused(); }
      syncPaused() {
        this.toggleAttribute('data-paused', this.pauseReasons.size > 0);
        this.toggleAttribute('data-paused-by-user', this.pauseReasons.has('user'));
      }
      syncPlayBtn() {
        if (!this.playBtn) return;
        var paused = this.pauseReasons.has('user');
        this.playBtn.toggleAttribute('data-paused', paused);
        this.playBtn.setAttribute('aria-label', paused ? this.playBtn.dataset.labelPlay : this.playBtn.dataset.labelPause);
      }

      /* ---------- Grid: rellena la última fila para que no queden huecos ---------- */
      layoutGrid() {
        if (!this.grid) return;
        var all = this.grid.querySelectorAll('[data-pps-item]');
        all.forEach(function (el) {
          el.removeAttribute('data-fill-d'); el.removeAttribute('data-fill-m');
        });
        var items = this.visible(this.grid);
        if (this.gridWrap) this.gridWrap.hidden = items.length === 0;
        // Escritorio: banners por fila reales (para calcular una altura común)
        var colsD = parseInt(this.dataset.colsD, 10) || 4;
        this.grid.style.setProperty('--g-row', Math.max(1, Math.min(items.length, colsD)));
        if (!this.hasAttribute('data-grid-fill') || !items.length) return;
        var desktop = this.mq.matches;
        if (desktop) return; // en escritorio el CSS reparte el ancho completo
        if (this.classList.contains('pps-hero--m-rail')) return;
        var cols = parseInt(desktop ? this.dataset.colsD : this.dataset.colsM, 10) || 1;
        var rest = items.length % cols;
        if (!rest) return;
        var span = 12 / rest;
        var normal = 12 / cols;
        var key = desktop ? 'd' : 'm';
        items.slice(items.length - rest).forEach(function (el) {
          el.setAttribute('data-fill-' + key, '');
          el.style.setProperty('--fill-span-' + key, Math.round(span));
          // Si todo el grid cabe en una fila, los banners solo se ensanchan; si es la
          // última fila de varias, se mantiene la altura de las filas de arriba.
          el.style.setProperty('--fill-scale-' + key, items.length < cols ? 1 : span / normal);
        });
      }

      /* ---------- Editor de temas ---------- */
      onEditorSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        var el = this.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        this.pause('editor');
        if (!el || !this.track || !this.track.contains(el)) return;
        var idx = (this.items || []).indexOf(el);
        if (idx > -1) this.go(Math.floor(idx / this.perView));
      }
      onEditorDeselect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        this.resume('editor');
      }
    }

    customElements.define('pps-hero-promo', PpsHeroPromo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart-scrolltabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Keep the sticky tab bar pinned right below the (sticky) theme header.
    // The --header-height variable is not reliable on every template, so we
    // measure the real header section height and expose it as --size-tabs-top.
    function setStickyOffset() {
      const header = document.querySelector('.header-section');
      const tabs = document.querySelector('.size_tabs');
      if (!tabs) return;
      const headerH = header ? header.offsetHeight : 0;
      tabs.style.setProperty('top', headerH + 'px');
      // Offset anchor jumps so the brand title lands below header + sticky tabs.
      document.documentElement.style.setProperty(
        '--size-anchor-offset',
        headerH + tabs.offsetHeight + 16 + 'px'
      );
    }

    function initSizeTabs() {
      setStickyOffset();
      window.addEventListener('resize', setStickyOffset);

      const listSizes = document.getElementById('list-sizes');
      if (!listSizes || listSizes.dataset.built === 'true') return;
      listSizes.dataset.built = 'true';

      const sizes = document.querySelectorAll('.size-chart-section');
      sizes.forEach((section) => {
        const id = section.id;
        const name = id.replace('size-chart-', '');

        const link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = name;
        link.addEventListener('click', () => {
          document
            .querySelectorAll('#list-sizes li')
            .forEach((li) => li.classList.remove('active'));
          link.closest('li').classList.add('active');
        });

        const li = document.createElement('li');
        li.appendChild(link);
        listSizes.appendChild(li);
      });

      const leftButton = document.querySelector('.size-tabs-wrapper .arrow.left');
      const rightButton = document.querySelector('.size-tabs-wrapper .arrow.right');
      if (!leftButton || !rightButton) return;

      function checkScroll() {
        const scrollLength = listSizes.scrollWidth - listSizes.clientWidth;
        const current = listSizes.scrollLeft;

        if (current <= 0) {
          leftButton.setAttribute('disabled', 'true');
          if (listSizes.scrollWidth <= listSizes.clientWidth + 1) {
            rightButton.setAttribute('disabled', 'true');
          } else {
            rightButton.removeAttribute('disabled');
          }
        } else if (current + 1 >= scrollLength) {
          rightButton.setAttribute('disabled', 'true');
          leftButton.removeAttribute('disabled');
        } else {
          leftButton.removeAttribute('disabled');
          rightButton.removeAttribute('disabled');
        }
      }

      leftButton.addEventListener('click', () => listSizes.scrollBy({ left: -200, behavior: 'smooth' }));
      rightButton.addEventListener('click', () => listSizes.scrollBy({ left: 200, behavior: 'smooth' }));
      listSizes.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
      checkScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeTabs);
    } else {
      initSizeTabs();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart-table"] && !Shopify.designMode) return;
  try {
    
  // Gender switcher — event delegation so it works for every brand section
  // regardless of script load timing (no per-section init required).
  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-gender-select]');
    if (!option) return;
    const section = option.closest('.size-chart-section');
    if (section) {
      section.dataset.selectedGender = option.dataset.genderSelect;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
